import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type ResilienceDashboard } from '../../api/resilience';

const NAV = [
  { to: '/resilience', label: 'Resilience Hub' },
  { to: '/resilience/backups', label: 'Backup Center' },
  { to: '/resilience/recovery', label: 'Recovery Center' },
  { to: '/resilience/replication', label: 'Replication Monitor' },
  { to: '/resilience/disaster', label: 'DR Console' },
  { to: '/resilience/runbooks', label: 'Recovery Runbooks' },
  { to: '/resilience/integrity', label: 'Integrity Dashboard' },
  { to: '/resilience/continuity', label: 'Business Continuity' },
  { to: '/resilience/restore', label: 'Restore Wizard' },
];

export function ResilienceHubPage() {
  const [dash, setDash] = useState<ResilienceDashboard | null>(null);
  useEffect(() => { void resilienceApi.dashboard().then(setDash); }, []);
  const stats = dash ? [
    { label: 'Total Backups', value: dash.total_backups },
    { label: 'Verified', value: dash.verified_backups },
    { label: 'Recovery Plans', value: dash.recovery_plans },
    { label: 'Replication Healthy', value: `${dash.replication_healthy}/${dash.replication_total}` },
    { label: 'RTO (current/target)', value: `${dash.current_rto_seconds}s / ${dash.target_rto_seconds}s` },
    { label: 'RPO (current/target)', value: `${dash.current_rpo_seconds}s / ${dash.target_rpo_seconds}s` },
    { label: 'Last Drill', value: dash.last_drill_passed ? 'Passed' : 'Failed' },
    { label: 'Integrity Rate', value: `${(dash.integrity_pass_rate * 100).toFixed(0)}%` },
  ] : [];
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Enterprise Resilience Platform</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Backup, disaster recovery, high availability and business continuity.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">{NAV.map((l) => <Link key={l.to} to={l.to} className="text-emerald-700 hover:underline dark:text-emerald-400">{l.label}</Link>)}</nav>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">{stats.map((s) => (
        <div key={s.label} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900"><p className="text-sm text-slate-500">{s.label}</p><p className="mt-1 text-xl font-semibold">{String(s.value)}</p></div>
      ))}</div>
    </div>
  );
}
